/**
 * Created by Mark on 10/04/2017.
 */



import React from "react";
import { FormattedMessage } from 'react-intl';
import CDNImage from '../media/image.js';
import CDNAudio from '../../classes/audio.js';
import {Tooltip , OverlayTrigger , Collapse , Nav , Row , NavItem , Table}from 'react-bootstrap';
import ScoresService from '../../services/scores-services.js';
import StoreStore from '../../store/scores-store.js';
import InternationalizationStore from '../../store/internationalization-store.js';
import MedalGraphic from '../../components/media/medal.image.js';
import Tests from '../../classes/tests.js';
export default class ModulesClassScores extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.moduleID   = props.moduleID;
        this.classID    = props.classID;
        this.hasCatalog = props.hasCatalog || false;
        this.testsOnly  = true;

        this.state = {tabIndex:0 , data : null , testsOnly:true};
        this.handelTabSelect = this.handelTabSelect.bind(this);
    }

    handelTabSelect(tabIndex){
        this.setState({tabIndex:tabIndex})
    }


    componentWillReceiveProps(props)
    {
        if(props.data) this.setState({data:props.data , testsOnly:props.data.modules.length > 1});

    }


    renderModuleTitles(){

        if(!this.state.data) return;

        let columns = [];


        for(var moduleIndex = 0 ; moduleIndex < this.state.data.modules.length; moduleIndex++)
        {
            columns.push(<th width={30*(this.state.testsOnly ? this.state.data.tests.length : this.state.data.games.length)} colSpan={this.state.testsOnly ? this.state.data.tests.length : this.state.data.games.length}><center>{InternationalizationStore.getModuleNoIndexTranslation(this.state.data.modules[moduleIndex].title)}</center></th>)
        }

        return columns;
    }

    shouldRenderSubTitles(){
        if(!this.state.data) return;
        var modules = this.state.data.modules;
        var cols = [];
        for(var moduleIndex = 0 ; moduleIndex < modules.length; moduleIndex++) {
            //if(!this.state.testsOnly)cols.push(<th colSpan={this.state.data.games.length}>Games</th>);
            //if(!this.state.testsOnly)cols.push(<th colSpan={this.state.data.tests.length}>TESTS</th>);
        }

        return cols;
    }

    renderGamesIcons(){
        var cols = [];

        if(!this.state.data) return;

        var modules = this.state.data.modules;

        for(var moduleIndex = 0 ; moduleIndex < modules.length; moduleIndex++) {
            for(var testIndex = 0 ; testIndex < this.state.data.tests.length; testIndex++)
            {
                let tooltip = (
                <Tooltip id="tooltip"><strong><FormattedMessage id={ String((new Tests()).getSkillTranslationGraphic(this.state.data.tests[testIndex].type))} defaultMessage={ "Download Report" } /></strong> Check this info.</Tooltip>
            );
                let testPath = (new Tests()).getSkillGraphic(this.state.data.tests[testIndex].type);
                cols.push(<OverlayTrigger placement="top" overlay={tooltip}>
                    <td className={!this.state.testsOnly ? "p-5 test-highlight" : "p-5"}>

                        <CDNImage size={30} src={testPath} />

                </td></OverlayTrigger>)
            }
        }

        if(!this.state.testsOnly)
        {
            for(var gamesIndex = 0 ; gamesIndex < this.state.data.games.length; gamesIndex++)
            {
                cols.push(<td className="p-5"><CDNImage  size={30} src={"img/gameselectionimages/" + this.state.data.games[gamesIndex].picture} /></td>)
            }
        }


        return cols;
    }

    isAverage(){
        return this.state.tabIndex == 1;
    }

    getScoreObject(games , gameID){
        if(games.length == 0 ) return null;

        for(var idx= 0 ; idx < games.length; idx++){
            if(games[idx].game_uid == gameID) return games[idx];
        }

       return null;
    }

    renderBody(){
        if(!this.state.data) return;

        var tbody = [];

        var modules = this.state.data.modules;

        for(var idx = 0; idx < this.state.data.students.length; idx++)
        {
            var columns = [<td>{this.state.data.students[idx].name}</td>];
            var student = this.state.data.students[idx];


            for(var moduleIndex = 0 ; moduleIndex < modules.length; moduleIndex++) {
                var moduleID = modules[moduleIndex].uid;

                for(var testIndex = 0 ; testIndex < this.state.data.tests.length; testIndex++)
                {
                    var gameID  = this.state.data.tests[testIndex].uid;
                    var gameObj = this.getScoreObject(student.scores.tests[moduleID] , gameID);

                    if(gameObj)
                    {
                        columns.push(<td width="30" className={!this.state.testsOnly ? "test-highlight" : ""} width="30">{gameObj.max}</td>);
                    }
                    else
                    {
                        columns.push(<td width="30" className={!this.state.testsOnly ? "test-highlight" : ""}>-</td>);
                    }
                }

                if(!this.state.testsOnly)
                {
                    for(var gamesIndex = 0 ; gamesIndex < this.state.data.games.length; gamesIndex++)
                    {
                        var gameID  = this.state.data.games[gamesIndex].uid;
                        var gameObj = this.getScoreObject(student.scores.games[moduleID] , gameID);

                        if(gameObj)
                        {
                            columns.push(<td width="30">{this.isAverage() ? gameObj['average_score'] : gameObj.score}</td>);
                        }
                        else
                        {
                            columns.push(<td width="30" >-</td>);
                        }
                    }
                }

            }

            tbody.push(<tr>{columns}</tr>)
        }

        return tbody
    }


    render(){
        return (
            <Collapse in={this.state.data != null} className="p-0 m-t-30">
                <div>
                    <Row>
                        <Table responsive bordered>
                            <thead>
                            <tr>
                                <th rowSpan={3}></th>
                                {this.renderModuleTitles()}
                            </tr>
                            <tr>
                                {this.shouldRenderSubTitles()}
                            </tr>
                            <tr>
                                {this.renderGamesIcons()}
                            </tr>
                            </thead>
                            <tbody>
                            {this.renderBody()}
                            </tbody>
                        </Table>
                    </Row>
                </div>
            </Collapse>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/tables/modules-tests-table.js